"use strict";
window.parser = new DOMParser();// --- Three-Tier Task Scheduling (Phase 2, jm-2.0.0) ---
// Tier 1: Critical — runs immediately (default, no wrapper needed)
// Tier 2: Interaction-deferred — runs on first user interaction or after 3s
// Tier 3: Idle — runs via requestIdleCallback or 5s fallback

// --- Tier 2: Interaction-deferred ---
(function () {
  var interactionEvents = ['pointerdown', 'keydown', 'scroll'];
  var deferQueue = [];
  var activated = false;

  function runDeferredTasks() {
    if (activated) return;
    activated = true;
    interactionEvents.forEach(function (e) {
      window.removeEventListener(e, runDeferredTasks);
    });
    for (var i = 0; i < deferQueue.length; i++) {
      try { deferQueue[i](); } catch (err) { console.warn('[Deferred Task Error]', err); }
    }
    deferQueue = [];
  }

  interactionEvents.forEach(function (e) {
    window.addEventListener(e, runDeferredTasks, { passive: true });
  });
  setTimeout(function () { if (!activated) runDeferredTasks(); }, 3000);

  window.deferUntilInteraction = function (fn) {
    if (activated) { try { fn(); } catch (e) { console.warn('[Deferred Task Error]', e); } }
    else { deferQueue.push(fn); }
  };
})();

// --- Tier 3: Idle scheduler ---
window.deferUntilIdle = function (fn, timeoutMs) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () {
      try { fn(); } catch (e) { console.warn('[Idle Task Error]', e); }
    }, { timeout: timeoutMs || 5000 });
  } else {
    setTimeout(function () {
      try { fn(); } catch (e) { console.warn('[Idle Task Error]', e); }
    }, 2000);
  }
};

// --- DOM Auto-Loader (Phase 1.1, jm-2.0.0) ---
// Scans for [data-module] attributes and dynamically imports the matching
// import map specifier. Only loads each module once. Re-scans on Theme Editor
// section load and theme:dom-updated events.
(function () {
  var loaded = {};

  // Resolve through the import map first, then fall back to the plain asset
  // URL from window.themeModuleUrls (see import-map.liquid). A browser that
  // never applied the import map rejects every bare specifier, which would
  // otherwise leave <product-form>, the variant pickers and the cart drawer
  // unregistered for the whole visit.
  function loadModule(spec) {
    if (loaded[spec]) return loaded[spec];
    var url = (window.themeModuleUrls || {})[spec];
    var promise = import(spec).catch(function (err) {
      if (!url) throw err;
      console.warn('[AutoLoader] Bare specifier failed, retrying by URL:', spec, err);
      return import(url);
    });
    promise.catch(function (err) {
      console.warn('[AutoLoader] Failed to load module:', spec, err);
    });
    loaded[spec] = promise;
    return promise;
  }

  function scan(root) {
    root = root || document;
    var els = root.querySelectorAll('[data-module]');
    for (var i = 0; i < els.length; i++) {
      var spec = els[i].getAttribute('data-module');
      if (spec) loadModule(spec);
    }
  }

  // Initial scan after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme Editor: re-scan when sections are added/reloaded
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }

  // Re-scan after dynamic DOM replacements (cart drawer, quickview, recommendations)
  document.addEventListener('theme:dom-updated', function (e) {
    if (e.detail && e.detail.container) { scan(e.detail.container); }
  });

  // Expose for manual use
  window.theme = window.theme || {};
  window.theme.scanModules = scan;
  window.theme.loadModule = loadModule;
})();

// --- Add-to-cart safety net (jm-2.0.x) ---
// <product-form> and its siblings are registered by lazily imported modules.
// When such an import never resolves — blocked request, an import map the
// browser refused, a content blocker — nothing cancels the form's default
// submit: the browser POSTs natively to /cart/add while the variant id input
// is still disabled, Shopify answers "Required parameter missing or invalid:
// items" as a full page, and the shopper loses the product page entirely.
// Observed in the wild in Firefox with content blockers installed, where none
// of the import map modules had run. This never lets that POST leave.
(function () {
  var HOSTS = 'product-form, product-form-bundle, product-form-quick-edit';
  var MODULE_FOR_HOST = {
    'product-form': 'theme:product-form',
    'product-form-bundle': 'theme:bundle-components',
    'product-form-quick-edit': 'theme:bundle-components'
  };
  var retried = {};

  // A server-rendered variant id is always safe to submit, so do not leave it
  // disabled while the module is still on its way. An input without a value
  // stays disabled — that is the "no variant selected yet" state.
  function enableVariantIds(root) {
    var inputs = (root || document).querySelectorAll(
      'form[data-type="add-to-cart-form"] input[name="id"][disabled]'
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value) inputs[i].disabled = false;
    }
  }

  function showLoadError(form) {
    var host = form.closest(HOSTS);
    var wrapper =
      host && host.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var message = wrapper.querySelector('.product-form__error-message');
    if (message) {
      message.textContent =
        (window.cartStrings && window.cartStrings.error) ||
        'Something went wrong. Please reload the page and try again.';
    }
    wrapper.hidden = false;
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

      var host = form.closest(HOSTS);
      // Either not a custom-element-driven form, or the element is registered
      // and has already attached its own handler — leave it alone.
      if (!host || window.customElements.get(host.localName)) return;

      // Never let this reach Shopify as a native POST.
      evt.preventDefault();
      evt.stopPropagation();

      var tag = host.localName;
      if (retried[tag]) {
        showLoadError(form);
        return;
      }
      retried[tag] = true;

      var spec = MODULE_FOR_HOST[tag];
      var load =
        spec && window.theme && window.theme.loadModule
          ? window.theme.loadModule(spec)
          : Promise.reject(new Error('module loader unavailable'));

      load
        .then(function () {
          // define() upgrades the element synchronously, so by now the real
          // handler is attached and requestSubmit replays the click through it.
          if (window.customElements.get(tag) && form.requestSubmit) {
            form.requestSubmit();
          } else {
            showLoadError(form);
          }
        })
        .catch(function () {
          showLoadError(form);
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enableVariantIds(); });
  } else {
    enableVariantIds();
  }
  document.addEventListener('theme:dom-updated', function (e) {
    if (e.detail && e.detail.container) enableVariantIds(e.detail.container);
  });
})();

// --- Accessibility: prefers-reduced-motion (Phase 6.2, jm-2.0.0) ---
window.theme = window.theme || {};
window.theme.config = window.theme.config || {};
window.theme.config.motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

var BlsLazyloadImg = (function () {
  var _observed = new WeakSet();
  function _removeBlur(img, instant) {
    if (!img || !img.classList.contains("bls-loading-image")) return;
    var me = img.closest("motion-element");
    if (instant) {
      img.style.transition = "none";
      if (me) me.style.transition = "none";
    }
    if (me) me.classList.remove("bls-loading-image");
    img.classList.remove("bls-loading-image");
    if (instant) {
      requestAnimationFrame(function() {
        img.style.transition = "";
        if (me) me.style.transition = "";
      });
    }
  }
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const img = entry.target;
                // Rewrite width/height/sizes ONLY for lazy images that have
                // not started loading: that is the original intent (pick the
                // right srcset candidate before the fetch). Rewriting eager or
                // already-complete images re-layouts and can re-fetch a new
                // srcset candidate seconds after first paint — on throttled
                // devices this re-promoted the first product card image to a
                // late LCP candidate (PSI: LCP 16.4s while the image itself
                // loaded in 60ms).
                if (img.loading === "lazy" && !(img.complete && img.naturalWidth > 0)) {
                  const w = entry.boundingClientRect.width;
                  if (w > 0) {
                    img.width = w;
                    img.height = entry.boundingClientRect.height;
                    img.sizes = `${w}px`;
                  }
                }
                if (img.complete && img.naturalWidth > 0) {
                  _removeBlur(img, true);
                } else {
                  img.addEventListener("load", function onLoad() {
                    img.removeEventListener("load", onLoad);
                    _removeBlur(img);
                  });
                  setTimeout(() => _removeBlur(img), 3000);
                }
                observer.unobserve(img);
              }
            });
          },
          { rootMargin: "600px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          if (!_observed.has(img)) {
            _observed.add(img);
            observer.observe(img);
          }
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish("closeCanvas", data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            image.classList.remove("bls-loading-image");
            resolve();
          }, 100);
        } else {
          image.addEventListener("load", (e) => {
            e.currentTarget
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            e.currentTarget.classList.remove("bls-loading-image");
            resolve();
          });
        }
      });
    })
  );
};

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === "true";
    const revealSlideshow = _this?.dataset.revealSlideshow === "true";
    const centeredSlidesAttr = _this?.dataset.centeredSlides;
    const centeredSlidesSetting =
      centeredSlidesAttr === undefined
        ? slideShow && parseFloat(itemDesktop) === 1.5
        : centeredSlidesAttr === "true";
    const customNavigation = _this?.dataset.customNavigation === "true";
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);

    // When using multiple slides per view
    const enableMultiVisibleContent =
      slideShow && !revealSlideshow && Number(itemDesktop) > 1;
    _this.classList.toggle("swiper-multi", enableMultiVisibleContent);

    const getVisibleSlides = (swiper, excludeActive = false) => {
      if (!swiper?.slides) return [];
      return Array.from(swiper.slides).filter((slide) => {
        if (!slide.classList.contains("swiper-slide-visible")) return false;
        if (excludeActive && slide.classList.contains("swiper-slide-active")) {
          return false;
        }
        return true;
      });
    };

    const preInitVisibleMotions = (swiper, excludeActive = false) => {
      if (!slideShow) return;
      getVisibleSlides(swiper, excludeActive).forEach((slide) => {
        slide
          .querySelectorAll("motion-element[slideshow]")
          .forEach((motion) => {
            if (motion.hasAttribute("hold")) return;
            motion.preInitialize?.();
          });
      });
    };

    const initVisibleMotions = (swiper, excludeActive = false) => {
      if (!slideShow) return;
      getVisibleSlides(swiper, excludeActive).forEach((slide) => {
        slide
          .querySelectorAll("motion-element[slideshow]")
          .forEach((motion) => {
            if (motion.hasAttribute("hold")) return;
            motion.classList.remove("animate-delay");
            motion.initialize?.();
          });
      });
    };
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grabCursor: true,
      centeredSlides: centeredSlidesSetting,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: customNavigation ? document.querySelector(`.${customNext}`) : _this.querySelector(".swiper-button-next"),
        prevEl: customNavigation ? document.querySelector(`.${customPrev}`) : _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: paginationCustom == undefined ?
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination") : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: false
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: centeredSlidesSetting,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            if (typeof Motion !== "undefined" && Motion.inView) {
              Motion.inView(
                _this,
                async () => {
                  e.autoplay.start();
                },
                { margin: "0px 0px -50px 0px" }
              );
            } else {
              e.autoplay.start();
            }
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }


          // initialize motion elements for the visible non-active slide(s) too.
          if (slideShow) {
            requestAnimationFrame(() => {
              preInitVisibleMotions(e, true);
              setTimeout(() => {
                initVisibleMotions(e, true);
              }, 50);
            });
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                index_currentSlide +
                "']"
              )
              .classList.add("active");
          }
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          preInitVisibleMotions(this);
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          initVisibleMotions(this);
        },
        afterInit: function () {
          if (slideShow && revealSlideshow && itemDesktop <= 3) {
            _this.duplicateSlides(this);
          }
        },
        touchMove: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        }
      },
    });
  }

  duplicateSlides(swiper) {
    const _this = this;
    const swiperWrapper = _this.querySelector('.swiper-wrapper');
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const paginationEl = _this.querySelector('.swiper-pagination');

    if (paginationEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList.contains('swiper-pagination-bullet')) {
                const allBullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                const bulletIndex = Array.from(allBullets).indexOf(node);
                if (bulletIndex >= originalSlides.length) {
                  node.classList.add('swiper-pagination-duplicate');
                }
              }
            });
          }
        });
        observer.disconnect();
      });

      observer.observe(paginationEl, { childList: true });
    }

    originalSlides.forEach((slide) => {
      const clonedSlide = slide.cloneNode(true);
      clonedSlide.classList.add('swiper-slide-duplicate');
      swiperWrapper.appendChild(clonedSlide);
    });

    swiper.update();
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      if (!tiktok) return;
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass, modalWidth) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector(".tingle-modal-box");
        if (modalWidth) {
          modalBoxContent.style.setProperty("--popup-max-width", modalWidth);
        }
        document.dispatchEvent(new CustomEvent("modal:opened"));
        document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() { }
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (!elementErrorMessage) return;
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      if (elementMessage) elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  if (typeof Motion !== "undefined" && Motion.animate) {
    Motion.animate(
      toast,
      {
        opacity: [0, 1],
        scale: [0.3, 1],
      },
      {
        duration: 0.3,
        easing: "ease-out",
      }
    );
  } else {
    toast.style.opacity = "1";
    toast.style.transform = "scale(1)";
  }

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  if (typeof Motion !== "undefined" && Motion.animate) {
    Motion.animate(
      toast,
      { opacity: 0, scale: 0.5 },
      { duration: 0.2, easing: "ease-in" }
    ).then(() => {
      toast.remove();
    });
  } else {
    toast.remove();
  }
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      "loading" === document.readyState
        ? document.addEventListener(
          "DOMContentLoaded",
          this._loadEverythingReadyNow.bind(this)
        )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll(
      ".lazy-loading-swiper-after"
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll(".review-product-added");
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            if (typeof Motion !== "undefined" && Motion.inView) {
              Motion.inView(
                _this,
                async () => {
                  e.autoplay.start();
                },
                { margin: "0px 0px -50px 0px" }
              );
            } else {
              e.autoplay.start();
            }
          }
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide motion-element:not([data-image])"
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute("hold")) {
              slide?.setAttribute("hold", true);
            }
          });
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                index_currentSlide +
                "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event("mmspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement("script");
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          "type" !== t &&
            ("data-mmlazy-type" === t && ((t = "type"), (n = e.nodeValue)),
              s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute("src")
            ? (s.addEventListener("load", t), s.addEventListener("error", t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("mmspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("mmspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("mmspeed-readystatechange")),
      await this._requestAnimFrame(),
      document.mmonreadystatechange && document.mmonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event("mmspeed-load")),
      await this._requestAnimFrame(),
      window.mmonload && window.mmonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("mmspeed-pageshow")),
      await this._requestAnimFrame(),
      window.mmonpageshow && window.mmonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.content).then(() => {
        this.classList.add("copied");
      }).catch(() => {
        this._fallbackCopy(this.content);
      });
    } else {
      this._fallbackCopy(this.content);
    }
  }
  _fallbackCopy(text) {
    if (window.theme && window.theme.fallbackCopy) {
      window.theme.fallbackCopy(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);
